import CircularLoader from "../common/CircularLoader/CircularLoader";
import statusCheckIcon from "../../assets/images/bankStatements/status-check.svg";
import { PulseBankAccount } from "./types";
import {
  hasProcessingDocuments,
  hasVisibleRangeError,
  isAccountFailed,
  isActivePipelineStatus,
  isDocumentPasswordRequired,
  pipelineStatusFromAccount,
  pluralize,
} from "./utils";
import styles from "./BankStatements.module.scss";

export type AccountStatusTone = "processing" | "complete" | "failed" | null;

export const AccountStatusRow = ({
  fileLabel,
  tone,
}: {
  fileLabel: string;
  tone: AccountStatusTone;
}) => (
  <div className={styles.statusRow}>
    <span className={styles.fileCount}>{fileLabel}</span>
    {tone === "processing" ? (
      <span className={`${styles.statusChip} ${styles.processing}`}>
        <span className={styles.statusLoader} aria-hidden="true">
          <CircularLoader width="0.75rem" height="0.75rem" />
        </span>
        Processing
      </span>
    ) : tone === "complete" ? (
      <span className={`${styles.statusChip} ${styles.complete}`}>
        <img src={statusCheckIcon} alt="" />
        Complete
      </span>
    ) : tone === "failed" ? (
      <span className={`${styles.statusChip} ${styles.failed}`}>
        Needs attention
      </span>
    ) : null}
  </div>
);

export const AccountStatus = ({ account }: { account: PulseBankAccount }) => {
  const status = pipelineStatusFromAccount(account);
  const processing =
    hasProcessingDocuments(account.documents) ||
    (isActivePipelineStatus(status) &&
      !account.documents.some(isDocumentPasswordRequired));
  const requiresPassword = account.documents.some(isDocumentPasswordRequired);
  // Same signals as the checklist, so the chip and the checklist agree.
  const needsAttention =
    isAccountFailed(account) ||
    requiresPassword ||
    hasVisibleRangeError(account);
  const tone: AccountStatusTone = processing
    ? "processing"
    : needsAttention
    ? "failed"
    : status === "complete" || status === "failed"
    ? // a FAILURE with no remaining error labels counts as complete
      "complete"
    : null;
  return (
    <AccountStatusRow
      fileLabel={`${pluralize(account.documents.length, "file")} uploaded`}
      tone={tone}
    />
  );
};
